import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function usePatientClaims() {
  const documentKey = useParams<'documentKey'>().documentKey as string

  const options = apiClient.getAllPatientClaimsDocumentsDocumentKeyEobClaimsGetOptions({
    path: { document_key: documentKey },
  })

  return useSuspenseQuery({
    ...options,
    queryFn: async (ctx) => {
      try {
        return await options.queryFn!(ctx)
      } catch (error) {
        if (error instanceof Error && (error as Error & { status?: number }).status === 404) {
          return { patient_claims: [] } as apiClient.PatientClaimsResponse
        }
        throw error
      }
    },
    staleTime: Infinity,
  })
}
